<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb
                v-if="hasRoleToReadLogs"
                style="float: right"
                separator-class="el-icon-arrow-right"
            >
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'playerList' }">{{$t('entities.player.plural')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ model.id }}</el-breadcrumb-item>
            </el-breadcrumb>

            <h2 class="page-title">{{$t('entities.player.singular')}}</h2>
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content bg-purple"></div>
                    <el-form
                        :label-position="labelPosition"
                        :label-width="labelWidth"
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item v-if="hasRoleToReadLogs" label="Id">{{ model.id }}</el-form-item>

                        <!-- <el-form-item
                            :label="$t('entities.player.prop.namePublic')"
                        >{{ model.namePublic }}</el-form-item> -->

                        <el-form-item :label="$t('entities.player.prop.name')">{{ model.name }}</el-form-item>

                        <el-form-item
                            :label="$t('entities.player.prop.lastName')"
                        >{{ model.lastName }}</el-form-item>

                        <el-form-item :label="$t('entities.player.prop.dni')">{{ model.dni }}</el-form-item>

                        <el-form-item :label="$t('entities.player.prop.birthdate')">{{ getDateFormat(model.birthdate) }}</el-form-item>

                        <!-- <el-form-item :label="$t('entities.player.prop.email')">{{ model.email }}</el-form-item> -->

                        <el-form-item :label="$t('entities.player.prop.dorsal')">{{ model.dorsal }}</el-form-item>

                        <!-- <el-form-item :label="$t('entities.player.prop.phone')">{{ model.phone }}</el-form-item> -->

                        <el-form-item :label="$t('entities.player.prop.position')">
                            <app-entity-link entityName="position" :property="model.position"></app-entity-link>
                        </el-form-item>
                        <el-form-item :label="$t('entities.player.prop.picture')">
                            <img :src="model.picture.url" class="image" width="10%" height="10%">
                        </el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            label="Created at"
                        >{{ model.created | formatDatetime }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            label="Updated at"
                        >{{ model.modified | formatDatetime }}</el-form-item>

                        <div class="button-group mt-3">
                            <el-button
                                v-if="hasRoleToUpdate"
                                icon="el-icon-fa-pencil-square-o"
                                @click="edit()"
                                type="primary"
                            >{{$t('table.edit')}}</el-button>
                            <el-button
                                v-if="hasRoleToReadLogs"
                                icon="el-icon-fa-history"
                                @click="history()"
                                type="infor"
                            >{{$t('table.history')}}</el-button>
                            <el-button
                                v-if="hasRoleToDelete"
                                icon="el-icon-fa-trash"
                                @click="destroy()"
                                type="danger"
                            >{{$t('table.delete')}}</el-button>
                        </div>
                    </el-form>
                </el-col>

                <!-- Right -->
                <el-col :span="8">
                    <div class="grid-content bg-purple"></div>
                    <h3 class="page-title">{{$t('entities.team.singular')}}</h3>
                    <el-form
                        :label-position="labelPosition"
                        :label-width="labelWidth"
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item v-if="hasRoleToReadLogs" label="Id">{{ model.team.id }}</el-form-item>

                        <el-form-item :label="$t('entities.team.prop.name')">{{ model.team.name }}</el-form-item>

                        <el-form-item :label="$t('entities.team.prop.category')">{{ model.team.category.label }}</el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';    // birthdate
import Cookies from 'js-cookie' // birthdate
/* eslint-disable */

export default {
    name: "app-player-show",

    props: {
        id: String
    },

    data() {
        return {
            labels: {
                name: "Nombre",
                lastName: "Apellidos",
                picture: "Foto",
                dni: "Dni/Nie/Pasaporte",
                email: "Email de contacto",
                dorsal: "Dorsal",
                phone: "Teléfono",
                position: "Posición",
                namePublic: "Nombre deportivo"
            }
        };
    },
    created() {
        this.$store
            .dispatch("entities/player/detail", this.id)
            .catch(() => this.$router.push({ name: "playerList" }));
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/player/model",
            loading: "entities/player/loading",
            hasRoleToDelete: "entities/player/hasRoleToDelete",
            hasRoleToUpdate: "entities/player/hasRoleToUpdate",
            hasRoleToRead: "entities/player/hasRoleToRead",
            hasRoleToReadLogs: "entities/player/hasRoleToReadLogs",
            hasRoleToCreate: "entities/player/hasRoleToCreate",
            isMobile: "shared/isMobile",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth"
        })
    },

    methods: {
        edit() {
            this.$router.push({
                name: "playerEdit",
                params: { id: this.id, previous: "show" }
            });
        },

        destroy() {
            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
            confirmButtonText: this.$t("table.yes"),
            cancelButtonText: this.$t("table.no"),
            type: 'warning',
        })
                .then(() =>
                    this.$store.dispatch("entities/player/destroy", this.model)
                )
                .then(() => this.$router.go(-1))
                .catch(() => {});
        },

        history() {
            this.$router.push({
                name: "playerHistorySingle",
                params: { id: this.id }
            });
        },

        // Aux functions
        getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));
            
            return moment(dateString, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/player/player-show.vue?1c0d861a